export const ROLES = {
  ROOT: 'root',
  ADMIN: 'admin',
  USER: 'user',
  API: 'api',
  TEC_TENANT: 'tec_tenant',
};

export const CONFIG_ROLES = [ROLES.ROOT, ROLES.TEC_TENANT];

export const isConfigRole = (role) => CONFIG_ROLES.includes(role);
